// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.manage-license {
  padding-bottom: 30px;
}

.manage-product {
  margin-bottom: 0;
  margin-top: 30px;
  padding-bottom: 20px;
}

.bill-under-text {
  margin-top: 5px;
  display: inline-block;
}

.display-column {
  display: flex;
  flex-wrap: wrap;
}

.alert {
  margin-bottom: 0;
  margin-top: 20px;
}

.manage-icon-img {
  margin-bottom: 20px;
  margin-top: 30px;
  padding: 0;
}
.manage-icon-img a {
  font-family: Omnes-ATT-W02 !important;
  font-size: 18px;
  padding: 0;
}
.manage-icon-img .icon-size {
  font-size: 26px;
  margin-right: 10px;
  padding: 0;
}

hr {
  margin-bottom: 30px;
  margin-top: 0;
}

.license-product .check-fan {
  background: hsl(0, 0%, 95%);
  padding-bottom: 116px;
}
.license-product .fan-card {
  border-top: 1px dotted #c4c4c4;
}
.license-product .fan-card:first-of-type {
  border-top: 0;
}
.license-product .fan-card .license-tile {
  margin-top: 20px;
}
.license-product .msg {
  padding-left: 15px;
}
.license-product h2 {
  margin-bottom: 0;
}
.license-product p {
  margin-bottom: 0;
  margin-top: 30px;
  padding: 0;
}

.license-tile {
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  background: white;
  border: 1px solid #d2d2d2;
  float: left;
  margin: 0 10px 30px;
  padding: 20px 20px 86px;
  position: relative;
  width: calc(33.33% - 20px);
}

section {
  word-wrap: break-word;
}

.container-box .license-product:first-of-type h2 {
  margin-top: 30px;
}

.popup-header {
  padding: 30px;
  position: relative;
}
.popup-header h2 {
  font-size: 30px;
  font-weight: normal;
  margin: 0;
  outline: none;
  padding: 0;
}

.popup-body {
  padding: 0 30px 20px;
}
.popup-body hr {
  margin: 20px 0;
}
.popup-body h2 {
  font-size: 30px;
  margin-bottom: 20px;
}
.popup-body .current-prod {
  margin-bottom: 10px;
}
.popup-body .form-group {
  margin-bottom: 0;
}
.popup-body .assign-prod label {
  margin-bottom: 5px;
}
.popup-body .prod-desc {
  padding-right: 5px;
}
.popup-body .new {
  width: 100%;
}
.popup-body .text-danger {
  margin-bottom: 0;
}

.popup-footer {
  border-radius: 8px;
  bottom: 0;
  padding: 0 30px;
  position: relative;
  width: 100%;
}
.popup-footer .btn-click {
  float: right;
  margin-left: 30px;
}
.popup-footer hr {
  margin: 30px 0 20px;
}
.popup-footer a {
  margin-bottom: 20px;
}

@media (max-width: 1024px) {
  .manage-license {
    padding-bottom: 30px;
  }
  .manage-product {
    margin-bottom: 0;
    margin-top: 20px !important;
  }
  .display-column {
    display: block;
    padding-bottom: 10px;
  }
  .license-tile {
    float: none;
    margin: auto auto 20px;
    max-width: 420px;
    padding-bottom: 64px;
    width: calc(100% - 30px) !important;
  }
  .manage-icon-img {
    margin-top: 30px;
  }
  .manage-icon-img .icon-size {
    float: left;
  }
  .msg {
    margin-bottom: 10px;
  }
  hr {
    margin-bottom: 30px;
  }
  .seperator {
    border-right: 0;
  }
  .seperator-left {
    border-left: 0;
    padding-left: 0;
    margin-left: 0;
  }
  .license-product .check-fan {
    padding-bottom: 64px;
  }
  .license-product .fan-card:first-of-type p {
    margin-top: 30px;
  }
  .license-product .msg {
    margin-bottom: 10px;
  }
  .license-product p {
    margin-bottom: 0;
    margin-top: 20px;
    padding: 0;
  }
  .license-product .license-list {
    border-right: 0;
    margin-right: 0;
    padding-right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/manage-licenses/manage-licenses.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJA;EACE,oBAAA;AAkJF;;AA/IA;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;AAkJF;;AA/IA;EACE,eAAA;EACA,qBAAA;AAkJF;;AA/IA;EACE,aAAA;EACA,eAAA;AAkJF;;AA/IA;EACE,gBAAA;EACA,gBAAA;AAkJF;;AA/IA;EACE,mBAAA;EACA,gBAAA;EACA,UAAA;AAkJF;AAhJE;EACE,qCAAA;EACA,eAAA;EACA,UAAA;AAkJJ;AA/IE;EACE,eAAA;EACA,kBAAA;EACA,UAAA;AAiJJ;;AA7IA;EACE,mBAAA;EACA,aAAA;AAgJF;;AA5IE;EACE,2BAAA;EACA,qBAAA;AA+IJ;AA5IE;EACE,8BAAA;AA8IJ;AA5II;EACE,aAAA;AA8IN;AA3II;EACE,gBAAA;AA6IN;AAzIE;EACE,kBAAA;AA2IJ;AAxIE;EACE,gBAAA;AA0IJ;AAvIE;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;AAyIJ;;AApIA;EFjDI,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EEmDF,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,0BAAA;AA2IF;;AAxIA;EACE,qBAAA;AA2IF;;AArIM;EACE,gBAAA;AAwIR;;AAlIA;EACE,aAAA;EACA,kBAAA;AAqIF;AAnIE;EACE,eAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;AAqIJ;;AAjIA;EACE,oBAAA;AAoIF;AAlIE;EACE,cAAA;AAoIJ;AAjIE;EACE,eAAA;EACA,mBAAA;AAmIJ;AAhIE;EACE,mBAAA;AAkIJ;AA/HE;EACE,gBAAA;AAiIJ;AA7HI;EACE,kBAAA;AA+HN;AA3HE;EACE,kBAAA;AA6HJ;AA1HE;EACE,WAAA;AA4HJ;AAzHE;EACE,gBAAA;AA2HJ;;AAvHA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AA0HF;AAxHE;EACE,YAAA;EACA,iBAAA;AA0HJ;AAvHE;EACE,mBAAA;AAyHJ;AAtHE;EACE,mBAAA;AAwHJ;;AFnRI;EEgKF;IACE,oBAAA;EAuHF;EApHA;IACE,gBAAA;IACA,2BAAA;EAsHF;EAnHA;IACE,cAAA;IACA,oBAAA;EAqHF;EAlHA;IACE,WAAA;IACA,sBAAA;IACA,gBAAA;IACA,oBAAA;IACA,mCAAA;EAoHF;EAjHA;IACE,gBAAA;EAmHF;EAjHE;IACE,WAAA;EAmHJ;EA/GA;IACE,mBAAA;EAiHF;EA9GA;IACE,mBAAA;EAgHF;EA7GA;IACE,eAAA;EA+GF;EA5GA;IACE,cAAA;IACA,eAAA;IACA,cAAA;EA8GF;EAzGE;IACE,oBAAA;EA2GJ;EAtGM;IACE,gBAAA;EAwGR;EAnGE;IACE,mBAAA;EAqGJ;EAlGE;IACE,gBAAA;IACA,gBAAA;IACA,UAAA;EAoGJ;EAjGE;IACE,eAAA;IACA,eAAA;IACA,gBAAA;EAmGJ;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","//license styles start\n@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.manage-license {\n  padding-bottom: 30px;\n}\n\n.manage-product {\n  margin-bottom: 0;\n  margin-top: 30px;\n  padding-bottom: 20px;\n}\n\n.bill-under-text {\n  margin-top: 5px;\n  display: inline-block;\n}\n\n.display-column {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.alert {\n  margin-bottom: 0;\n  margin-top: 20px;\n}\n\n.manage-icon-img {\n  margin-bottom: 20px;\n  margin-top: 30px;\n  padding: 0;\n\n  a {\n    font-family: Omnes-ATT-W02 !important;\n    font-size: 18px;\n    padding: 0;\n  }\n\n  .icon-size {\n    font-size: 26px;\n    margin-right: 10px;\n    padding: 0;\n  }\n}\n\nhr {\n  margin-bottom: 30px;\n  margin-top: 0;\n}\n\n.license-product {\n  .check-fan {\n    background: color(default, base);\n    padding-bottom: 116px;\n  }\n\n  .fan-card {\n    border-top: 1px dotted color(default, darker);\n\n    &:first-of-type {\n      border-top: 0;\n    }\n\n    .license-tile {\n      margin-top: 20px;\n    }\n  }\n\n  .msg {\n    padding-left: 15px;\n  }\n\n  h2 {\n    margin-bottom: 0;\n  }\n\n  p {\n    margin-bottom: 0;\n    margin-top: 30px;\n    padding: 0;\n  }\n\n}\n\n.license-tile {\n  @include vendor-prefix('border-radius', 8px);\n  background: color(default, light);\n  border: 1px solid color(default, dark);\n  float: left;\n  margin: 0 10px 30px;\n  padding: 20px 20px 86px;\n  position: relative;\n  width: calc(33.33% - 20px);\n}\n\nsection {\n  word-wrap: break-word;\n}\n\n.container-box {\n  .license-product {\n    &:first-of-type {\n      h2 {\n        margin-top: 30px;\n      }\n    }\n  }\n}\n\n.popup-header {\n  padding: 30px;\n  position: relative;\n\n  h2 {\n    font-size: 30px;\n    font-weight: normal;\n    margin: 0;\n    outline: none;\n    padding: 0;\n    }\n  }\n\n.popup-body {\n  padding: 0 30px 20px;\n\n  hr {\n    margin: 20px 0;\n  }\n\n  h2 {\n    font-size: 30px;\n    margin-bottom: 20px;\n  }\n\n  .current-prod {\n    margin-bottom: 10px;\n  }\n\n  .form-group {\n    margin-bottom: 0;\n  }\n\n  .assign-prod {\n    label {\n      margin-bottom: 5px;\n    }\n  }\n\n  .prod-desc {\n    padding-right: 5px;\n  }\n\n  .new {\n    width: 100%;\n  }\n\n  .text-danger {\n    margin-bottom: 0;\n  }\n}\n\n.popup-footer {\n  border-radius: 8px;\n  bottom: 0;\n  padding: 0 30px;\n  position: relative;\n  width: 100%;\n\n  .btn-click {\n    float: right;\n    margin-left: 30px;\n   }\n\n  hr {\n    margin: 30px 0 20px;\n  }\n\n  a {\n    margin-bottom: 20px;\n  }\n}\n\n@include respond-to (small) {\n  .manage-license {\n    padding-bottom: 30px;\n  }\n\n  .manage-product {\n    margin-bottom: 0;\n    margin-top: 20px !important;\n  }\n\n  .display-column {\n    display: block;\n    padding-bottom: 10px;\n  }\n\n  .license-tile {\n    float: none;\n    margin: auto auto 20px;\n    max-width: 420px;\n    padding-bottom: 64px;\n    width: calc(100% - 30px) !important;\n  }\n\n  .manage-icon-img {\n    margin-top: 30px;\n\n    .icon-size {\n      float: left;\n    }\n  }\n\n  .msg {\n    margin-bottom: 10px;\n  }\n\n  hr {\n    margin-bottom: 30px;\n  }\n\n  .seperator {\n    border-right: 0;\n  }\n\n  .seperator-left {\n    border-left: 0;\n    padding-left: 0;\n    margin-left: 0;\n  }\n\n  .license-product {\n  \n    .check-fan {\n      padding-bottom: 64px;\n    }\n\n    .fan-card {\n      &:first-of-type {\n        p {\n          margin-top: 30px;\n        }\n      }\n    }\n\n    .msg {\n      margin-bottom: 10px;\n    }\n\n    p {\n      margin-bottom: 0;\n      margin-top: 20px;\n      padding: 0;\n    }\n\n    .license-list {\n      border-right: 0;\n      margin-right: 0;\n      padding-right: 0;\n    }\n  }\n\n}\n\n// license style end here\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
